export default "__VITE_ASSET__DITtcV1s__"